import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React__default, { useRef, useState, useMemo, useCallback, useEffect, createRef, useLayoutEffect } from 'react';
import { useResizeDetector } from 'react-resize-detector/build/withPolyfill';
import './Tabs.scss.js';
import { useHistory, useLocation } from 'react-router-dom';
import { classnames } from '../../../utils/classnames.js';
import Menu, { MenuContext } from '../Menu/Menu.js';
import Button from '../Button/Button.js';
import AllMenuHorizontal from '../../../assets/icons/resultDir/AllMenuHorizontal.js';

var Tabs = function Tabs(_ref) {
  var list = _ref.list,
      _ref$showLine = _ref.showLine,
      showLine = _ref$showLine === void 0 ? true : _ref$showLine,
      _ref$showMenu = _ref.showMenu,
      showMenu = _ref$showMenu === void 0 ? true : _ref$showMenu,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      children = _ref.children;
  var history = useHistory();

  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;
  /** Ссылки на вкладки */


  var tabRefs = useRef([]);
  /** Ссылка на линию */

  var lineRef = useRef(null);
  /** Ссылка на последний индекс таба, который показан */

  var _useState = useState(list.length - 1),
      _useState2 = _slicedToArray(_useState, 2),
      lastVisibleIndex = _useState2[0],
      setLastVisibleIndex = _useState2[1];
  /** Определяем, если вкладки являются ссылками для роутинга */


  var isRouting = useMemo(function () {
    return list.every(function (t) {
      return t.url;
    });
  }, [list]);
  /** Устанавливаем индекс последнего видимого таба */

  var onResize = useCallback(function (width) {
    handleLastVisibleIndex(width);
  }, [showMenu, list]);

  var _useResizeDetector = useResizeDetector({
    onResize: onResize,
    refreshMode: 'throttle',
    refreshRate: 300
  }),
      rootRef = _useResizeDetector.ref;

  useEffect(function () {
    if (!showMenu) {
      setLastVisibleIndex(list.length - 1);
    } else {
      handleLastVisibleIndex(getWidthTab(rootRef.current));
    }
  }, [showMenu]);
  useEffect(function () {
    onResize(getWidthTab(rootRef.current));
  }, [list]);
  useEffect(function () {
    setActive(function (i) {
      var index = list.findIndex(function (t) {
        if (isRouting && t.url) {
          return t.exact ? t.url === pathname : pathname.includes(t.url);
        }

        return t.active;
      });
      return index >= 0 && !list[index].disabled ? index : i;
    });
  }, [list, pathname, isRouting]); // -------------------------------------------------------------------------------------------------------------------

  /** Определяем ширину таба */

  var getWidthTab = function getWidthTab(element) {
    return (element === null || element === void 0 ? void 0 : element.getBoundingClientRect().width) || 0;
  };
  /** Получаем индекс последнего видимого таба */


  var handleLastVisibleIndex = function handleLastVisibleIndex() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    var _a, _b;

    var MENU_WIDTH = 48;
    var visibleIndex = 0;
    var visibleWidth = MENU_WIDTH;

    for (var index = 0; index < list.length; index++) {
      if ((_b = (_a = tabRefs.current) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.current) {
        if (width > visibleWidth + getWidthTab(tabRefs.current[index].current)) {
          visibleWidth += getWidthTab(tabRefs.current[index].current);
        } else {
          break;
        }
      }

      visibleIndex = index;
    }

    setLastVisibleIndex(visibleIndex);
  }; // -------------------------------------------------------------------------------------------------------------------

  /** Определяем активную вкладку */


  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      active = _useState4[0],
      setActive = _useState4[1];
  /** Определяем является ли активный таб в меню */


  var isActiveIndexInMenu = active > lastVisibleIndex;
  /** Управление полоской */

  var setLinePosition = function setLinePosition(element) {
    if (lineRef.current) {
      var width = element.offsetWidth;
      var x = element.offsetLeft;

      if (isActiveIndexInMenu) {
        lineRef.current.style.width = '0px';
      } else {
        lineRef.current.style.left = "".concat(x, "px");
        lineRef.current.style.width = "".concat(width, "px");
      }
    }
  };
  /** Устанавливаем активную вкладку */


  var onClick = function onClick(e, i, element) {
    var _a, _b;

    element && setLinePosition(element);

    if (isRouting && list[i].url && active !== i) {
      history.push(list[i].url);
    }

    setActive(i);
    (_b = (_a = list[i]).handler) === null || _b === void 0 ? void 0 : _b.call(_a, tabRefs.current[i].current);
  }; // -------------------------------------------------------------------------------------------------------------------

  /** Список вкладок */


  var nav = list.map(function (t, i) {
    if (!tabRefs.current[i]) {
      tabRefs.current[i] = /*#__PURE__*/createRef();
    }

    var onMenuClickHandler = function onMenuClickHandler(e) {
      return onClick(e, i, tabRefs.current[i].current);
    };

    return /*#__PURE__*/React__default.createElement("div", {
      key: i,
      className: classnames('rf-tabs__link', i > lastVisibleIndex && 'rf-tabs__link--hidden'),
      ref: tabRefs.current[i],
      "data-v-6e52f9c7": ""
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: classnames('rf-tabs__button', i === active && 'rf-tabs__button--active', "rf-tabs__button--".concat(size)),
      disabled: t.disabled,
      onClick: onMenuClickHandler,
      "data-v-6e52f9c7": ""
    }, !!t.icon && /*#__PURE__*/React__default.createElement("div", {
      className: "rf-tabs__icon",
      "data-v-6e52f9c7": ""
    }, t.icon), !!t.label && /*#__PURE__*/React__default.createElement("div", {
      "data-v-6e52f9c7": ""
    }, t.label)));
  });
  /** Список вкладок в меню */

  var menuNav = /*#__PURE__*/React__default.createElement(MenuContext.Consumer, null, function (_ref2) {
    var onClose = _ref2.onClose;
    return list.reduce(function (acc, curr, i) {
      if (i > lastVisibleIndex) {
        var onMenuClickHandler = function onMenuClickHandler(e) {
          onClick(e, i, tabRefs.current[i].current);
          onClose();
        };

        return [].concat(_toConsumableArray(acc), [/*#__PURE__*/React__default.createElement("div", {
          key: i,
          className: classnames('rf-tabs__link', 'rf-tabs__menu-link'),
          "data-v-6e52f9c7": ""
        }, /*#__PURE__*/React__default.createElement("button", {
          type: "button",
          className: classnames('rf-tabs__button', 'rf-tabs__menu-button', i === active && 'rf-tabs__menu-button--active'),
          disabled: curr.disabled,
          onClick: onMenuClickHandler,
          "data-v-6e52f9c7": ""
        }, !!curr.icon && /*#__PURE__*/React__default.createElement("div", {
          className: classnames('rf-tabs__icon', 'rf-tabs__menu-icon'),
          "data-v-6e52f9c7": ""
        }, curr.icon), !!curr.label && /*#__PURE__*/React__default.createElement("div", {
          "data-v-6e52f9c7": ""
        }, curr.label)))]);
      }

      return acc;
    }, []);
  });
  /** Определяем есть ли табы в меню */

  var hasMenuNav = showMenu && lastVisibleIndex < list.length - 1;
  /** Устанавливаем линию на активную вкладку при инициализации */

  useLayoutEffect(function () {
    if (nav.length > 0 && tabRefs.current[active].current) {
      var element = tabRefs.current[active].current;
      element && setLinePosition(element);
    }
  }, [nav]); // -------------------------------------------------------------------------------------------------------------------

  return /*#__PURE__*/React__default.createElement("div", {
    className: "rf-tabs rf-tabs--buttons",
    ref: rootRef,
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("nav", {
    className: classnames('rf-tabs__navigation', showLine && 'rf-tabs__navigation__line'),
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "rf-tabs__navigation-list",
    "data-v-6e52f9c7": ""
  }, nav, hasMenuNav && /*#__PURE__*/React__default.createElement(Menu, {
    content: /*#__PURE__*/React__default.createElement("div", {
      className: "button-group__menu",
      "data-v-6e52f9c7": ""
    }, menuNav),
    position: "top-start",
    className: classnames('rf-tabs__menu', isActiveIndexInMenu && 'rf-tabs__menu--active'),
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement(Button, {
    buttonType: "ghost",
    size: "l",
    "data-testid": "button-menu-group__more",
    className: "rf-tabs__menu__btn",
    startAdornment: /*#__PURE__*/React__default.createElement(AllMenuHorizontal, {
      "data-v-6e52f9c7": ""
    }),
    "data-v-6e52f9c7": ""
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "rf-tabs__navigation-line",
    ref: lineRef,
    "data-v-6e52f9c7": ""
  })), (isRouting && children || !isRouting && list.length > 0) && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-tabs__content",
    "data-v-6e52f9c7": ""
  }, isRouting && children ? children : list[active].tab));
};

export { Tabs as default };
